export default {
  mounted() {
    if (this.el.dataset.prevent_text_selection === 'true') {
      ['contextmenu', 'copy', 'dragstart', 'dragleave', 'selectstart'].forEach((event) => {
        this.el.addEventListener(event, function(event) {
          event.preventDefault();
        });
      });
    }
  },
}
